// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../../../types/schema';

import { Cashflows_CashflowFragment } from '../../../../../../../cashflows/CashflowDrawer/graphql/Cashflows.generated';
import { LiabilitiesTable_LiabilityFragment } from '../../../../../../../liabilities/LiabilitiesTable/graphql/LiabilitiesTable.generated';
import { gql } from '@apollo/client';
import { Cashflows_CashflowFragmentDoc } from '../../../../../../../cashflows/CashflowDrawer/graphql/Cashflows.generated';
import { LiabilitiesTable_LiabilityFragmentDoc } from '../../../../../../../liabilities/LiabilitiesTable/graphql/LiabilitiesTable.generated';
export type EstateWaterfallAssumptionsSlide_GrowthProfileOverrideFragment = { __typename?: 'GrowthProfileOverride', id: string, customGrowthRate?: Percent | null, entityFutureValuationValue?: CurrencyUSD | null, entityFutureValuationYear?: number | null, entityGrowthBeforeFutureValuation?: Percent | null, entityGrowthAfterFutureValuation?: Percent | null, assetClass?: { __typename?: 'AssetClass', id: string, displayName: string, growthRate?: Percent | null } | null, entity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null };

export type EstateWaterfallAssumptionsSlide_GrowthProfileFragment = { __typename?: 'GrowthProfile', id: string, isDefault: boolean, displayName: string, assetGrowthReturn?: Percent | null, growthType: Types.GrowthProfileGrowthType, growthProfileOverrides: { __typename?: 'GrowthProfileOverrideConnection', edges?: Array<{ __typename?: 'GrowthProfileOverrideEdge', node?: (
        { __typename?: 'GrowthProfileOverride' }
        & EstateWaterfallAssumptionsSlide_GrowthProfileOverrideFragment
      ) | null } | null> | null } };

export type EstateWaterfallAssumptionsSlide_EstateWaterfallVizFragment = { __typename?: 'EstateWaterfallViz', firstDeathRemainingLifetimeExemption: CurrencyUSD, secondDeathRemainingLifetimeExemption: CurrencyUSD, firstGrantorRemainingLifetimeExemptionAtDeath: CurrencyUSD, secondGrantorRemainingLifetimeExemptionAtDeath?: CurrencyUSD | null, materializedInputParams: { __typename?: 'EstateWaterfallMaterializedInputParams', firstGrantorDeathYear: number, secondGrantorDeathYear?: number | null, selectedGrowthProfile?: (
      { __typename?: 'GrowthProfile' }
      & EstateWaterfallAssumptionsSlide_GrowthProfileFragment
    ) | null } };

export type EstateWaterfallAssumptionsSlide_CashflowFragment = (
  { __typename?: 'Cashflow', id: string }
  & Cashflows_CashflowFragment
);

export type EstateWaterfallAssumptionsSlide_LiabilityFragment = (
  { __typename?: 'Liability', id: string }
  & LiabilitiesTable_LiabilityFragment
);

export const Operations = {
  Fragment: {
    EstateWaterfallAssumptionsSlide_GrowthProfileOverride: 'EstateWaterfallAssumptionsSlide_GrowthProfileOverride' as const,
    EstateWaterfallAssumptionsSlide_GrowthProfile: 'EstateWaterfallAssumptionsSlide_GrowthProfile' as const,
    EstateWaterfallAssumptionsSlide_EstateWaterfallViz: 'EstateWaterfallAssumptionsSlide_EstateWaterfallViz' as const,
    EstateWaterfallAssumptionsSlide_Cashflow: 'EstateWaterfallAssumptionsSlide_Cashflow' as const,
    EstateWaterfallAssumptionsSlide_Liability: 'EstateWaterfallAssumptionsSlide_Liability' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateWaterfallAssumptionsSlide_GrowthProfileOverrideFragmentDoc = gql`
    fragment EstateWaterfallAssumptionsSlide_GrowthProfileOverride on GrowthProfileOverride {
  id
  assetClass {
    id
    displayName
    growthRate
  }
  entity {
    id
    subtype {
      id
      displayName
    }
  }
  customGrowthRate
  entityFutureValuationValue
  entityFutureValuationYear
  entityGrowthBeforeFutureValuation
  entityGrowthAfterFutureValuation
}
    `;
export const EstateWaterfallAssumptionsSlide_GrowthProfileFragmentDoc = gql`
    fragment EstateWaterfallAssumptionsSlide_GrowthProfile on GrowthProfile {
  id
  isDefault
  displayName
  assetGrowthReturn
  growthType
  growthProfileOverrides {
    edges {
      node {
        ...EstateWaterfallAssumptionsSlide_GrowthProfileOverride
      }
    }
  }
}
    ${EstateWaterfallAssumptionsSlide_GrowthProfileOverrideFragmentDoc}`;
export const EstateWaterfallAssumptionsSlide_EstateWaterfallVizFragmentDoc = gql`
    fragment EstateWaterfallAssumptionsSlide_EstateWaterfallViz on EstateWaterfallViz {
  materializedInputParams {
    selectedGrowthProfile {
      ...EstateWaterfallAssumptionsSlide_GrowthProfile
    }
    firstGrantorDeathYear
    secondGrantorDeathYear
  }
  firstDeathRemainingLifetimeExemption
  secondDeathRemainingLifetimeExemption
  firstGrantorRemainingLifetimeExemptionAtDeath
  secondGrantorRemainingLifetimeExemptionAtDeath
}
    ${EstateWaterfallAssumptionsSlide_GrowthProfileFragmentDoc}`;
export const EstateWaterfallAssumptionsSlide_CashflowFragmentDoc = gql`
    fragment EstateWaterfallAssumptionsSlide_Cashflow on Cashflow {
  id
  ...Cashflows_Cashflow
}
    ${Cashflows_CashflowFragmentDoc}`;
export const EstateWaterfallAssumptionsSlide_LiabilityFragmentDoc = gql`
    fragment EstateWaterfallAssumptionsSlide_Liability on Liability {
  id
  ...LiabilitiesTable_Liability
}
    ${LiabilitiesTable_LiabilityFragmentDoc}`;